import React, { type ReactNode } from 'react';

interface DropdownMenuItemProps {
    children: ReactNode;
}

const DropdownMenuItem = ({ children }: DropdownMenuItemProps) => {
    return (
        <li className="yat-dashboard-top-bar-user-navigation__item" role="none">
            {children}
        </li>
    );
};

export default DropdownMenuItem;
